export const isObjectEmpty = (objectName) => {

    return Object.keys(objectName).length === 0
}